import React from "react";
import certificates from "../../../resources/certificates";
import CarouselRow from "../../common/CarouselRow";
import ImageCard from "../../common/ImageCard";
import { useTranslation } from "react-i18next";

const Certificates = () => {
  const { t } = useTranslation("home");

  const gallery = certificates.map((certificate, index) => (
    <ImageCard src={certificate} key={index} children={index} />
  ));

  return (
    <div className="bg-gray-100 py-8 text-center space-y-4">
      <div className="text-2xl text-emerald-400 font-bold">
        {t("certificates.title")}
      </div>
      <CarouselRow children={gallery} />
    </div>
  );
};

export default Certificates;
